import type { ReactNode } from "react";
import "./page-shell.css";

export interface PageShellProps {
  header?: ReactNode;
  sidecar?: ReactNode;
  children: ReactNode;
}

/**
 * Three-region layout per design-system §11.1:
 *   header (sticky) · main (scroll) · optional sidecar (≥1280 only).
 * The sidecar slot is hidden via CSS below 1280 px without hiding the
 * markup, so route-specific pages can choose to omit it explicitly.
 */
export function PageShell({ header, sidecar, children }: PageShellProps) {
  return (
    <div className="wp-shell">
      {header ? <div className="wp-shell__header">{header}</div> : null}
      <div className="wp-shell__row">
        <main className="wp-shell__main" id="main">
          {children}
        </main>
        {sidecar ? (
          <aside className="wp-shell__sidecar" aria-label="Бічна панель">
            {sidecar}
          </aside>
        ) : null}
      </div>
    </div>
  );
}
